export default __webpack_public_path__ + "static/264-c2b978e8893de16827da2462b0e03544.gif";